export const getActive = (row, company) =>{
    return row.companies.filter(el=>el.id===company.id).length>0;
}